export class StoreKeys  {

    static Member = class {
      public static readonly Token = "token";
    }
  
    static Board = class {
      public static readonly SetupObject: string = "setupObject";
    }
  
    static Card = class {
      public static readonly Estimation: string = "estimation";
      public static readonly Goal: string = "goal";
      public static readonly Step: string = "step";
      public static readonly Release: string = "release";
    }
}

export default StoreKeys;